<template>
    <div class="c-group-history">
        <div class="c-group-history__table" ref="document">
            <v-data-table @click:row="rowClicked" :footer-props="{
                'items-per-page-options': itemsPerPageOptions,
                'show-first-last-page': true,
                'show-current-page': true,
                'items-per-page-text': 'Users per page',
            }" :headers="tableHeaders" :loading="loading" :loading-text="$t('animal.loadingAnimals')"
                :items="getAnimals" :items-per-page="itemsPerPage" :options.sync="tableOptions"
                class="elevation-1 px-2 py-2" hide-default-footer v-model="selected" show-select>
                <template v-slot:top>
                    <div class="d-flex mt-5">
                        <v-text-field prepend-inner-icon="mdi-magnify" outlined :placeholder="$t('search')" dense
                            v-model="search" @input="resetSearchOnEmpty" class="shrink">
                        </v-text-field>
                        <v-btn :disabled="search.length < 1" color="primary" height="40" width="40" max-width="40"
                            outlined class="ml-8" @click="searchAnimals">
                            <v-icon>mdi-filter-outline</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <div class="py-3">
                            {{ (tableOptions.page - 1) * tableOptions.itemsPerPage }} - {{ ((tableOptions.page - 1) *
                                    tableOptions.itemsPerPage) + count
                            }} of {{ totalCount }}
                        </div>
                        <v-btn class="mx-2" fab small outlined color="primary" :disabled="(tableOptions.page) == 1"
                            @click="pageChange(false)">
                            <v-icon dark> mdi-chevron-left </v-icon>
                        </v-btn>
                        <v-btn class="mx-2" fab small outlined color="primary"
                            :disabled="(((tableOptions.page - 1) * tableOptions.itemsPerPage) + count) >= totalCount"
                            @click="pageChange(true)">
                            <v-icon dark> mdi-chevron-right </v-icon>
                        </v-btn>
                        <v-btn class="mx-2" fab small outlined color="primary" @click="exportToPDF">
                            <v-img src="/icons/download.svg"></v-img>
                        </v-btn>
                        <v-btn class="mx-2" fab small outlined color="primary" @click="printPDF">
                            <v-icon dark> mdi-printer </v-icon>
                        </v-btn>
                        <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left :min-width="417">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on">
                                    <v-icon dark> mdi-cog-outline </v-icon>
                                </v-btn>
                            </template>

                            <v-card width="417">
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>{{
                                                    $t("customization")
                                            }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider></v-divider>
                                    <div class="pl-3 pt-2 font-weight-normal">
                                        {{ $t("recordsPerPage") }}
                                    </div>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-slider v-model="itemsPerPageSlider" :tick-labels="itemsPerPageOptions"
                                                :max="3" step="1" ticks="always" tick-size="4"></v-slider>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-n3"></v-divider>
                                </v-list>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-row>
                                            <v-col class="mt-n9" cols="6" v-for="header in headers" :key="header.value">
                                                <v-checkbox v-model="selectedHeaders" :label="header.text"
                                                    color="primary" :value="header.text" hide-details :disabled="
                                                        header.text == 'ID' || header.text == 'Tag'
                                                    "></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-layout justify-center>
                                    <v-card-actions class="mb-5">
                                        <v-spacer></v-spacer>

                                        <v-btn outlined color="primary" @click="resetDefaut" width="190">
                                            {{ $t("restoreDefault") }}
                                        </v-btn>
                                        <v-btn color="primary" @click="resetTableStructure" width="190">
                                            {{ $t("apply") }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-layout>
                            </v-card>
                        </v-menu>
                    </div>

                    <div class="d-flex mt-2" v-if="selected && selected.length">
                        <v-btn @click="showRemoveAnimalsDialog = true" depressed class="font-weight-bold my-2 mr-2" color="primary">
                            {{ $t('animal.removeAnimalToGroup') }}
                        </v-btn>
                        <v-btn @click="showCreateGroupFromExistingDialog = true" depressed class="font-weight-bold my-2" color="primary">
                            {{ $t('animal.moveAnimalToGroup') }}
                        </v-btn>
                    </div>
                </template>
                <template v-slot:progress>
                    <v-progress-linear color="primary" :height="8" indeterminate></v-progress-linear>
                </template>
                <template v-slot:no-data v-if="animals && animals.length < 1">
                    {{ $t("animal.noANIMALAVAILABLE") }}
                </template>

                <template v-slot:item.status="{ item }">
                    <v-btn outlined
                        :color="animalRemovalMenu.find(r => item.status === r.type) ? animalRemovalMenu.find(r => item.status === r.type).color : 'primary'"
                        rounded small>
                        {{ item.status }}
                    </v-btn>
                </template>

                <template v-slot:item.dob="{ item }">
                    {{ item.dob ? item.dob : '' | formatDate }}
                </template>

                <template v-slot:item.tagNumber="{ item }">
                    {{ item.tagNumber ? item.tagNumber : '' }}
                </template>

                <template v-slot:item.regDate="{ item }">
                    {{ item.regDate ? item.regDate : '' | formatDate }}
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-menu :close-on-content-click="false" offset-y :transition="false">
                        <template #activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>

                        <v-card class="action-list">
                            <v-list>
                                <v-list-item>
                                    <v-list-item-content style="cursor: default" @click="moveToGroup(item)">
                                        <v-list-item-title>{{ "Move to Group" }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click.prevent="assignZonetoAnimal(item)">
                                    <v-list-item-content style="cursor: default">
                                        <v-list-item-title>{{ "Assign Zone" }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-show="selected.length <= 1" @click="gotoPerformance(item.id)">
                                    <v-list-item-content style="cursor: default">
                                        <v-list-item-title>{{ "Check Performance" }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-show="selected.length <= 1" @click="clickEditAnimal(item.id)">
                                    <v-list-item-content style="cursor: default">
                                        <v-list-item-title>{{ "Edit Animal" }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click="archiveAnimal(item)">
                                    <v-list-item-content style="cursor: default">
                                        <v-list-item-title>{{ "Archive Animal" }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-menu>
                </template>
            </v-data-table>
            <create-group-from-existing-dialog
                @closeDialog="showCreateGroupFromExistingDialog = false"
                @group:selected="onExistingGroupSelected"
                @new-group:create="onNewGroupCreate"
                :dialogI="showCreateGroupFromExistingDialog"
                :groups="groups"
                v-if="showCreateGroupFromExistingDialog"
            />

            <create-group-dialog
                @closeDialog="showCreateGroupDialog = false"
                @group:created="onGroupCreated"
                :dialogI="showCreateGroupDialog"
                :newGroupName="newGroupName"
                v-if="showCreateGroupDialog"
            />

            <AssignZone
                @modal-closed="assignZoneModalClosed"
                :assignType="zoneAssignType"
                :dialogU="assignZoneModal"
                :group="selectedGroup"
                v-if="assignZoneModal"
            />

            <RemoveAnimalsDialog
                @modal:closed="showRemoveAnimalsDialog = false"
                @remove:animals="removeAnimals"
                :dialogI="showRemoveAnimalsDialog"
                v-if="showRemoveAnimalsDialog"
            />
        </div>
    </div>
</template>

<script>
/* eslint-disable */
// import loadingMixin from "@/mixins/LoadingMixin";

import gql from 'graphql-tag';
import html2pdf from "html2pdf.js";
import printJS from "print-js";
import RegisterAnimalDialog from "../RegisterAnimalDialog.vue";
import CreateGroupFromExistingDialog from "../CreateGroupFromExistingDialog.vue";
import RemoveAnimalsDialog from "./RemoveAnimalsDialog.vue";
import AssignZone from "../AssignZone.vue"
import CreateGroupDialog from "../CreateGroupDialog.vue";
import { archiveAnimal } from "@/graphql/Animals.gql"

export default {
    apollo: {
        animals: {
            query: gql`query animals(
                $page: Float,
                $limit: Float,
                $groupId: Int!,
                $search: String
            ) {
                findAnimalByGroup(
                    page: $page,
                    limit: $limit,
                    groupId: $groupId,
                    search: $search
                ) {
                count
                rows {
                    id
                    animalIdentification {
                        id
                        dateOfRegistration
                        livestockName
                        identificationMethods {                            
                            idNumber
                            chipNumber
                            tagNumber
                            tatooName
                            brandName
                            code
                            position
                            tagCategoryId
                        }
                    }
                    birthOrigin {
                        id
                        dateOfBirth
                    }
                    breed {
                        name
                        id
                    }
                    additionalInformation {
                        id
                        gender
                        animalPicture
                    }
                    gender
                    status
                    removalInformation {
                        id
                        reasonForRemoval
                    }
                }
                totalCount
                }
            }`,
            variables() {
                return {
                    page: this.tableOptions.page,
                    limit: this.tableOptions.itemsPerPage,
                    groupId: this.group ? parseInt(this.group.id) : null,
                    search: this.search,
                }
            },
            fetchPolicy: 'network-only',
            skip: () => true,
            update: data => data.findAnimalByGroup.rows,
            result({ data }) {
                this.totalCount = data.findAnimalByGroup.totalCount;
                this.count = data.findAnimalByGroup.count;
                this.loading = false;
            },
        },
        groups: {
            query: gql`query groups {
                groups {
                    groupData {
                        id
                        animalCounts
                        bodyWeight
                        name
                        status
                        geofenceZoneId {
                            id
                            geofenceName
                        }
                    },
                    groupToAnimals
                }
            }`,
            skip: () => false,
            fetchPolicy: 'network-only',
            update: (data) => data.groups.groupData,
            result({ data }) {
                this.groupToAnimals = data.groups.groupToAnimals
                this.groupData = data.groups.groupData
                for (let el in data.groups.groupToAnimals) {
                    this.animalIds.push(...data.groups.groupToAnimals[el])
                }

            }
        },
    },
    components: {
        "register-animal-dialog": RegisterAnimalDialog,
        'create-group-from-existing-dialog': CreateGroupFromExistingDialog,
        AssignZone,
        'create-group-dialog': CreateGroupDialog,
        RemoveAnimalsDialog,
    },
    computed: {
        getAnimals() {
            return this.animals?.map(animal => {
                return {
                    animalNumber: animal.animalIdentification?.livestockName,
                    breedId: animal.breed?.name,
                    dob: animal.birthOrigin?.dateOfBirth,
                    gender: animal.gender,
                    id: animal.id,
                    regDate: animal.animalIdentification && animal.animalIdentification.dateOfRegistration ? animal.animalIdentification.dateOfRegistration : '',
                    status: (animal.removalInformation && animal.removalInformation.reasonForRemoval) ? animal.removalInformation.reasonForRemoval : animal.status,
                    tagNumber: animal.animalIdentification && animal.animalIdentification.identificationMethods ? animal.animalIdentification.identificationMethods.map(identification => identification.idNumber || identification.chipNumber || identification.chipNumber).join(', ') : '',
                }
            });
        },
    },
    data() {
        return {
            animalIds: [],
            assignZoneModal: false,
            count: 0,
            selectedGroup: null,
            zoneAssignType: 'goal',
            showCreateGroupFromExistingDialog: false,
            menu: false,
            allSelectedHeaders: [
                this.$t("animal.owner"),
                this.$t("animal.dam"),
                this.$t("animal.birthWeight"),
                this.$t("animal.surrogateDam"),
                this.$t("animal.birthEase"),
                this.$t("status"),
                this.$t("animal.gender"),
                this.$t("animal.govtReg"),
                this.$t("id"),
                this.$t("animal.tag"),
                this.$t("animal.dateOfBirth"),
                this.$t("animal.regDate"),
                this.$t("animal.breed"),
                this.$t("animal.birthFarm"),
                this.$t("animal.sire"),
            ],
            animalRemovalMenu: [
                { type: this.$t("animal.slaughter"), color: 'error' },
                { type: this.$t("animal.movedToAnotherFarm"), color: 'primary' },
                { type: this.$t("animal.sale"), color: 'warning' },
                { type: this.$t("animal.death"), color: 'secondary' },
            ],
            headers: [
                {
                    text: this.$t("id"),
                    align: "start",
                    sortable: true,
                    value: "id",
                    width: "90px",
                },
                {
                    text: this.$t("animal.tag") + " #",
                    sortable: true,
                    value: "tagNumber",
                    width: "120px",
                },
                {
                    text: this.$t("animal.dateOfBirth"),
                    value: "dob",
                    sortable: true,
                    width: "140px",
                },
                {
                    text: this.$t("animal.gender"),
                    sortable: true,
                    value: "gender",
                    width: "120px",
                },
                {
                    text: this.$t("animal.breed"),
                    value: "breedId",
                    sortable: true,
                    width: "120px",
                },
                {
                    text: this.$t("animal.regDate"),
                    value: "regDate",
                    sortable: false,
                    width: "140px",
                },
                {
                    text: this.$t("Status"),
                    value: "status",
                    sortable: true,
                    width: "120px",
                },
                {
                    text: "",
                    value: "actions",
                    sortable: true,
                    width: "120px",
                },
            ],
            loading: false,
            newGroupName: '',
            totalCount: 0,
            totalPages: 1,
            pageCount: 0,
            itemsPerPage: 10,
            itemsPerPageSlider: 3,
            itemsPerPageOptions: [5, 10, 25, 50],
            search: "",
            selected: [],
            selectedHeaders: [],
            showCreateGroupDialog: false,
            showRemoveAnimalsDialog: false,
            tableOptions: {},
            tableHeaders: [],
        }
    },

    methods: {
        archiveAnimal(item) {
            this.startLoading()
            this.$apollo.mutate({
                mutation: archiveAnimal,
                variables: {
                    animalId: parseInt(item.id)
                }
            })
                .then(async ({ data }) => {
                    this.stopLoading()
                    if (data.archiveAnimal.success) {
                        await this.$apollo.queries.animals.refetch();
                    }
                })
                .catch(e => {
                    console.log('arc', e)
                    this.stopLoading()
                })
        },
        clickEditAnimal(id) {
            this.$router.push({
                name: 'EditAnimal',
                params: { animal_number: id },
            });
        },
        gotoPerformance(id) {
            this.$router.push(`/animals/${id}/performance`);
        },
        assignZoneModalClosed(success) {
            this.selectedGroup = null;
            this.assignZoneModal = false;
            if (success == true) {
                this.$apollo.queries.groups.refetch()
                this.getGroups()
            }
        },
        assignZonetoAnimal(item) {
            this.zoneAssignType = 'animal'
            this.selectedGroup = item;
            this.assignZoneModal = true;
        },
        async updateAnimal(animalToUpdate) {
            // this.startLoading();
            let formData = {
                animalId: parseInt(animalToUpdate.id),
                groupId: animalToUpdate.groupId,
            };

            this.$apollo.mutate({
                // Query
                mutation: gql`mutation ($data: UpdateAnimalGroup!) {
                    updateAnimalGroup (updateAnimalGroup: $data)
                }`,
                // Parameters
                variables: {
                    data: formData,
                },
            })
                .then((res) => {
                    if (res.data.updateAnimalGroup) {
                        // this.stopLoading();
                        this.$notify({
                            title: "Animal Group Updated Successfully",
                            text: "", //res.message,
                            type: "success",
                        });

                        this.$apollo.queries.animals.refetch();
                    } else {
                        // this.stopLoading();
                        this.$notify({
                            title: "Animal Group Not Updated",
                            text: res.message,
                            type: "error",
                        });
                    }
                })
                .catch(({ data }) => {
                    if (data.status == 422) {
                        data.message.errors.forEach((em) => {
                            this.errors[em.param] = em.msg;
                        });
                    }
                    this.stopLoading();
                });
        },
        moveToGroup(item) {
            this.selectedAnimal = item;
            this.showCreateGroupFromExistingDialog = true;
        },
        async assignAnimalsToGroup(animalIds, groupId) {
            // this.startLoading();
            let formData = {
                animalIds: animalIds,
                groupId: parseInt(groupId),
                oldGroupId: parseInt(this.group.id)
            };

            this.$apollo.mutate({
                // Query
                mutation: gql`mutation ($data: AssignAnimalsToGroupInput!) {
                    assignAnimalsToGroup (assignAnimalsToGroup: $data)
                }`,
                // Parameters
                variables: {
                    data: formData,
                },
            })
                .then((res) => {
                    if (res.data.assignAnimalsToGroup) {
                        // this.stopLoading();
                        this.$notify({
                            title: "Animal Group Updated Successfully",
                            text: "", //res.message,
                            type: "success",
                        });

                        this.$apollo.queries.animals.refetch();
                    } else {
                        // this.stopLoading();
                        this.$notify({
                            title: "Animal Group Not Updated",
                            text: res.message,
                            type: "error",
                        });
                    }
                })
                .catch(({ data }) => {
                    if (data.status == 422) {
                        data.message.errors.forEach((em) => {
                            this.errors[em.param] = em.msg;
                        });
                    }
                    this.stopLoading();
                });
        },
        async onExistingGroupSelected(existingGroupId) {
            if (this.selected && this.selected.length) {
                await this.assignAnimalsToGroup(this.selected.map(selectedAnimal => parseInt(selectedAnimal.id)), existingGroupId);

                this.showCreateGroupFromExistingDialog = false;
            }

            if (existingGroupId) {
                let animalToUpdate = {
                    id: this.selectedAnimal.id,
                    groupId: parseInt(existingGroupId)
                }
                await this.updateAnimal(animalToUpdate);
                this.showCreateGroupFromExistingDialog = false;
            }
        },
        onNewGroupCreate(newGroupName) {
            if (newGroupName) {
                this.newGroupName = newGroupName;
                this.showCreateGroupFromExistingDialog = false;
                this.showCreateGroupDialog = true;
            }
        },
        async onGroupCreated(newGroup) {
            if (this.selected && this.selected.length) {
                await this.assignAnimalsToGroup(this.selected.map(selectedAnimal => parseInt(selectedAnimal.id)), newGroup.id);

                this.showCreateGroupFromExistingDialog = false;
            } else {
                let animalToUpdate = {
                    id: this.selectedAnimal.id,
                    groupId: parseInt(newGroup.id)
                }

                await this.updateAnimal(animalToUpdate);
            }

        },
        pageChange(t) {
            if (t) this.tableOptions.page = this.tableOptions.page + 1;
            else this.tableOptions.page = this.tableOptions.page - 1;

            this.$apollo.queries.animals.skip = false;
            this.$apollo.queries.animals.refetch();
        },
        async exportToPDF() {
            html2pdf(this.$refs.document, {
                margin: 1,
                filename: "AnimalsList.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { dpi: 200, letterRendering: true },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "landscape",
                    compress: false,
                },
            });
        },
        async printPDF() {
            let opt = {
                margin: 1,
                filename: "AnimalsList.pdf",
                image: { type: "jpeg", quality: 0.95 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
            };

            let worker = await html2pdf()
                .set(opt)
                .from(this.$refs.document)
                .toCanvas()
                .outputPdf("blob", "AnimalsList.pdf");
            let file = new File([worker], "AnimalsList.pdf", {
                type: "application/pdf",
            });
            console.log(file);
            var pdfUrl = await URL.createObjectURL(file);
            console.log(pdfUrl);
            await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
        },
        rowClicked(item) {
            this.$router.push({
                name: "AnimalDetails",
                params: { animal_number: item.id, gender: item.gender },
            });
        },
        removeAnimals() {
            if (!this.selected || !this.selected.length) {
                return;
            }

            this.$apollo.mutate({
                // Query
                mutation: gql`mutation removeAnimalsFromGroup($data: RemoveAnimalsFromGroupInput!) {
                    removeAnimalsFromGroup(removeAnimalsFromGroup: $data)
                }`,
                // Parameters
                variables: {
                    data: {
                        animalIds: this.selected.map(selectedAnimal => parseInt(selectedAnimal.id)),
                        groupId: parseInt(this.group.id)
                    }
                },
            }).then(() => {
                this.showRemoveAnimalsDialog = false;
                this.$apollo.queries.animals.skip = false;
                this.$apollo.queries.animals.refetch();
            })
        },
        resetDefaut() {
            this.tableHeaders = this.headers;
            this.selectedHeaders = this.allSelectedHeaders;
            this.menu = false;
        },
        resetTableStructure() {
            // this.startLoading();
            this.tableHeaders = this.headers.filter((header) =>
                this.selectedHeaders.includes(header.text)
            );
            this.tableOptions.itemsPerPage = this.itemsPerPageOptions[
                this.itemsPerPageSlider
            ];
            this.menu = false;
            // this.stopLoading();
        },
        resetSearchOnEmpty() {
            if (this.search == "") return;

            this.tableOptions.page = 1;
            this.$apollo.queries.animals.refetch()
        },
        searchAnimals() {
            if (this.search == "") return;

            this.tableOptions.page = 1;
            this.$apollo.queries.animals.refetch()
        },
    },


    async mounted() {
        this.tableHeaders = this.headers;
        document.title = "Animals";
        this.selectedHeaders = this.allSelectedHeaders;
        this.tabletSelectHeaders = this.allSelectedHeaders.filter(
            (h) => h == "ID" || h == "Tag"
        );

        this.$apollo.queries.animals.skip = false;
        this.$apollo.queries.animals.refetch();
    },

    // mixins: [loadingMixin],

    props: {
        group: {
            required: true,
            type: Object,
        }
    }
}
</script>
